import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <>
    <g>
      <rect x="9" y="2" width="2" height="2" />
      <rect x="9" y="6" width="2" height="2" />
      <polygon points="13 4 15 4 15 2 13 2 11 2 11 4 11 6 13 6 13 4" />
      <polygon points="6 9 4 9 2 9 2 11 4 11 4 13 6 13 6 11 6 9" />
      <rect x="6" y="13" width="2" height="2" />
      <path d="M4,2h-2v6h6V2h-4ZM6,6h-2v-2h2v2Z" />
      <path d="M20,2h-4v6h6V2h-2ZM20,6h-2v-2h2v2Z" />
      <path d="M4,16h-2v6h6v-6h-4ZM6,20h-2v-2h2v2Z" />
      <rect x="9" y="20" width="2" height="2" />
      <rect x="2" y="13" width="2" height="2" />
    </g>
    <path d="M19.183,17.536c.525-.791.833-1.738.833-2.758,0-2.765-2.243-5.008-5.008-5.008s-5.008,2.243-5.008,5.008,2.243,5.008,5.008,5.008c1.021,0,1.967-.309,2.758-.833l2.837,2.837,1.416-1.416-2.836-2.837ZM15.008,17.782c-1.657,0-3.005-1.348-3.005-3.005s1.348-3.005,3.005-3.005,3.005,1.348,3.005,3.005-1.348,3.005-3.005,3.005Z" />
  </>,
  "SearchBarcode",
);
